import { Select, styled } from '@mui/material';

/**
 * A Select for a mode or an operation rather than data, tinted by the
 * theme's `tonalField` mixin.
 */
const TonalSelect = styled(Select)(
    ({ theme }) => theme.mixins.tonalField
) as unknown as typeof Select;

export default TonalSelect;
